import { RootState } from '..';
import { contactsEntityAdapter } from './profileSlice';

export const contactsSelectors = contactsEntityAdapter.getSelectors<RootState>(state => state.profile.contacts);
